/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    MediaFileMini,
    MediaFileMiniFromJSON,
    MediaFileMiniFromJSONTyped,
    MediaFileMiniToJSON,
    StornextManagerAttributes,
    StornextManagerAttributesFromJSON,
    StornextManagerAttributesFromJSONTyped,
    StornextManagerAttributesToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileBundle
 */
export interface MediaFileBundle {
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundle
     */
    id: number;
    /**
     * 
     * @type {Asset}
     * @memberof MediaFileBundle
     */
    asset?: Asset;
    /**
     * 
     * @type {MediaFileMini}
     * @memberof MediaFileBundle
     */
    mainfile: MediaFileMini;
    /**
     * 
     * @type {StornextManagerAttributes}
     * @memberof MediaFileBundle
     */
    snmAttributes: StornextManagerAttributes;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileBundle
     */
    readonly isShared: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundle
     */
    readonly fileCount: number;
    /**
     * 
     * @type {string}
     * @memberof MediaFileBundle
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundle
     */
    location: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaFileBundle
     */
    sharedViaTokens?: Array<number>;
}

export function MediaFileBundleFromJSON(json: any): MediaFileBundle {
    return MediaFileBundleFromJSONTyped(json, false);
}

export function MediaFileBundleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileBundle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': !exists(json, 'asset') ? undefined : AssetFromJSON(json['asset']),
        'mainfile': MediaFileMiniFromJSON(json['mainfile']),
        'snmAttributes': StornextManagerAttributesFromJSON(json['snm_attributes']),
        'isShared': json['is_shared'],
        'fileCount': json['file_count'],
        'name': json['name'],
        'location': json['location'],
        'sharedViaTokens': !exists(json, 'shared_via_tokens') ? undefined : json['shared_via_tokens'],
    };
}

export function MediaFileBundleToJSON(value?: MediaFileBundle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'asset': AssetToJSON(value.asset),
        'mainfile': MediaFileMiniToJSON(value.mainfile),
        'snm_attributes': StornextManagerAttributesToJSON(value.snmAttributes),
        'name': value.name,
        'location': value.location,
        'shared_via_tokens': value.sharedViaTokens,
    };
}


